
import { ReactComponent as ChevronLeft } from '../../../../../assets/frames_screen/arrow_left_slim.svg';
import { ReactComponent as ChevronRight } from '../../../../../assets/frames_screen/arrow_right_slim.svg';

import './FlyerArrow.scss'
import React from "react";
import {Box} from "@mui/material";

interface IFlyersArrow {
    disabled: boolean,
    onClick: (type: string) => void,
    arrowType: string
}

export const FlyerArrow: React.FC<IFlyersArrow> = (props) => {

    
    const classNames = () => {
        let classes = 'flyers_arrow_button';

        if (props.arrowType === 'left') {
            classes += ' arrowLeft';
        }
        if (props.arrowType === 'right') {
            classes += ' arrowRight';
        }

        if (props.disabled) {
            classes += ' disabledArrows';
        }

        return classes;
    }

    return (
        <Box sx={{
            border: `0`,
            position: `absolute`,
            zIndex: 3,
            height: "100%",
            width: "56px",
            top: "0",
            left: props.arrowType === 'right' ? "auto" : "0",
            right: props.arrowType === 'right' ? "0" : "auto",
            display: "flex",
            alignItems: "center",
            backgroundColor: `transparent`,
            "&:hover": {
                backgroundColor: `#CCDAE680`,
            },
        }}>
            <button
                disabled={props.disabled}
                onClick={() => props.onClick(props.arrowType)}
                className={classNames()}>

                { props.arrowType === 'left' ? <ChevronLeft /> : <ChevronRight /> }

            </button>

        </Box>
    )
}

